export default function sortByArrayUtil (array, iteratees) {
  if (!Array.isArray(array)) {
    throw new Error('Expected an array')
  }

  // Ensure iteratees is an array
  if (!Array.isArray(iteratees)) {
    iteratees = [iteratees]
  }

  return array.slice().sort((a, b) => {
    for (const iteratee of iteratees) {
      let aValue, bValue

      // If iteratee is a function, use it to get the values
      if (typeof iteratee === 'function') {
        aValue = iteratee(a)
        bValue = iteratee(b)
      } else {
        // Assume iteratee is a string (property name)
        aValue = a[iteratee]
        bValue = b[iteratee]
      }

      // Compare the values
      if (aValue > bValue) {
        return 1
      } else if (aValue < bValue) {
        return -1
      }
    }
    return 0
  })
}
